import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'
import { fetchCoverageEvents } from '../../services/coverageEventServices'
import { coverageEventQueryKeys } from '../CycleCounts/events/coverageEventQueryKeys'

// One cheap count: the list endpoint with per_page 1 and status open; total_count is the badge.
export const CoverageEventsBadge = () => {
  const { warehouse_id } = useParams()
  const { i18n } = useTranslation()
  const { data, error } = useQuery(
    coverageEventQueryKeys.openTotal(warehouse_id),
    () => fetchCoverageEvents({ warehouse_id, status: 'open', page: 1, per_page: 1 }),
    { staleTime: 60 * 1000, refetchOnWindowFocus: false, retry: false },
  )
  if (error) return null
  const total = data?.meta?.total_count ?? 0
  if (total === 0) return null
  return (
    <span
      className="ml-2 inline-flex items-center justify-center px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-600 text-white"
      title={i18n.t('cycle_counts.events.tab')}
      data-testid="coverage-events-badge"
    >
      {total}
    </span>
  )
}
